import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers-pro';
import { parseISO } from 'date-fns';
import { datePickerFormat } from 'helpers';

import FormInputErrorMessage from './form-input-error-message';

type Props = DatePickerProps<Date> & {
  label?: string;
  errorMessage?: string;
  helperText?: string | null;
};

const useStyles = makeStyles(() => ({
  input: {
    width: '100%',
    maxWidth: '100%',
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
  },
  helperText: {
    marginLeft: '5px',
    fontSize: '10px',
  },
}));

const FormDateField = ({ label, errorMessage, value, helperText, ...other }: Props) => {
  const classes = useStyles();

  const parsedValue = typeof value === 'string' ? parseISO(value) : value;

  return (
    <div className={classes.input}>
      {label && <Typography variant="caption">{label}</Typography>}
      <DatePicker
        orientation="landscape"
        format={datePickerFormat}
        value={parsedValue || undefined}
        {...other}
      />
      {errorMessage && <FormInputErrorMessage error={errorMessage} />}
      {helperText && <Typography className={classes.helperText}>{helperText}</Typography>}
    </div>
  );
};

export default FormDateField;
